import React from 'react';
import {connect} from 'react-redux';
import NavigationMenu from './NavigationMenu';
import buildNavItem from '../../../utils/NavItemBuilder';
import Loader from '../Loader';
import ProfilePic from '../ProfilePic';

class MainMenu extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            items: []
        };
    }

    componentWillMount() {
        this.buildItems(this.props);
    }

    buildItems(props) {
        let items = [
            buildNavItem({
                href: '/',
                text: 'Начало'
            }),
            buildNavItem({href: '/meditations', text: 'Медитации'}),
            buildNavItem({href: 'http://medita.bg/blog', text: 'Блог'}),
            buildNavItem({href:'/about-meditation', text:'За медитацията'}),
            buildNavItem({href:'/faq', text:'Въпроси'}),
        ];

        if (props.authenticated) {
            let text = <span>Профил<ProfilePic/></span>;

            if (props.userPending) {
                text = <Loader show={props.userPending} />;
            }

            items.push(buildNavItem({href: '/profile', text: text}));
        }
        else {
            items.push(buildNavItem({href: '/login', text: 'Вход' , className:'not-loggedin'}));
        }

        this.setState({items});
    }

    componentWillReceiveProps(newProps) {
        this.buildItems(newProps);
    }

    render() {
        return <NavigationMenu className={this.props.className} items={this.state.items} />
    }
}

const mapStateToProps = (state) => {
    return {
        userPending: state.user.userDataPending
    }
};

export default connect(mapStateToProps)(MainMenu);


// WEBPACK FOOTER //
// ./src/components/Presentation/Navigation/MainMenu.js